// import React from "react";
// import { Container } from "react-bootstrap";
// import './immersiveNew.css'
// const Partnership = () => {
//   return (
//     <div className="partnership-sectionnew">
//       <Container>
//         <div className="partnership-contentnew">
//           <h3 className=" text-uppercase mxr__section-title">Simulation Collective & MXR: A Powerful Partnership</h3>
//           <p>
//             Simulation Collective, a leader in healthcare simulation and training, has
//             partnered with MXR, experts in immersive technology, software, and hardware
//             development. Together, we bring a comprehensive solution to{" "}
//             <strong>upgrade, improve, and fully support </strong>your 
// immersive rooms and pods through our collaborative approach, addressing key pain 
// points and delivering impactful XR scenarios tailored to your needs.
//           </p>
//         </div>
//       </Container>
//     </div>
//   );
// };

// export default Partnership;


import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Partnership = () => {
  return (
    <div className="partnership-section py-5" style={{ background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)' }}>
      <Container>
        <Row className="justify-content-center align-items-center">
          <Col lg={10}>
            {/* <div className="text-center mb-4">
              <div className="icon-circle d-inline-block p-3 rounded-circle mb-3">
                <i className="bi bi-people-fill fs-2 text-primary"></i>
              </div>
            </div> */}
            
            <div className="partnership-content text-center">
              <h3 className="mxr__section-title  text-center mb-4">
                Simulation Collective & MXR: A Powerful Partnership
              </h3>
              
              <div className="position-relative">
                <p className="lead text-muted mb-4 mx-auto" style={{ maxWidth: '1000px' }}>
                  Simulation Collective, a leader in healthcare simulation and training, has
                  partnered with MXR, experts in immersive technology, software, and hardware
                  development. Together, we bring a comprehensive solution to{" "}
                  <strong className="siteColor">upgrade, improve, and fully support </strong>
                  your immersive rooms and pods through our collaborative approach, addressing key pain 
                  points and delivering impactful XR scenarios tailored to your needs.
                </p>
              </div>

              {/* <button className="btn btn-primary btn-lg hover-effect">
                Learn More About Our Partnership
                <i className="bi bi-arrow-right ms-2"></i>
              </button> */}
            </div>
          </Col>
        </Row>
      </Container>

    </div>
  );
};

export default Partnership;